import { render, staticRenderFns } from "./SelectArrowDownIcon.vue?vue&type=template&id=1154be92&"
import script from "./SelectArrowDownIcon.vue?vue&type=script&lang=ts&"
export * from "./SelectArrowDownIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports